export const ERASE_RADIUS_MIN = 8;
export const ERASE_RADIUS_MAX = 160;
export const ERASE_RADIUS_DEFAULT = 44;

const STORAGE_KEY = "mapus.erase-radius";

export interface PrefStore {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

/** Keep the brush inside the range. A bad number returns the default. */
export function clampEraseRadius(radius: number): number {
  if (!Number.isFinite(radius)) return ERASE_RADIUS_DEFAULT;
  const clamped = Math.min(ERASE_RADIUS_MAX, Math.max(ERASE_RADIUS_MIN, radius));
  return Math.round(clamped * 10) / 10;
}

/**
 * Wheel up grows the brush. `deltaY` is in pixels (negative when the wheel
 * goes up). One typical notch of 100 px changes the radius by 8 px.
 */
export function resizeEraseRadius(radius: number, deltaY: number): number {
  if (!Number.isFinite(deltaY) || deltaY === 0) return clampEraseRadius(radius);
  return clampEraseRadius(radius - deltaY / 12.5);
}

/** Line and page wheel modes become pixels before the radius step. */
export function eraseWheelPixels(deltaY: number, deltaMode: number): number {
  if (deltaMode === 1) return deltaY * 32;
  if (deltaMode === 2) return deltaY * 400;
  return deltaY;
}

export function readEraseRadius(store: PrefStore): number {
  try {
    const raw = store.getItem(STORAGE_KEY);
    if (raw == null || raw === "") return ERASE_RADIUS_DEFAULT;
    return clampEraseRadius(Number(raw));
  } catch {
    return ERASE_RADIUS_DEFAULT;
  }
}

export function writeEraseRadius(store: PrefStore, radius: number): void {
  try {
    store.setItem(STORAGE_KEY, String(clampEraseRadius(radius)));
  } catch {
    /* private mode */
  }
}
